var _a;
import React from "react";
import { useActivateDevice, useDevices } from "frontend/src/domain/devices";
import { ActivateDeviceFailureVariant } from "frontend/src/api/devices";
export var usePageDevices = function () {
    var devices = useDevices();
    return { devices: devices };
};
var activateDeviceErrorMap = (_a = {},
    _a[ActivateDeviceFailureVariant.BadRequest] = "Введите код устройства.",
    _a[ActivateDeviceFailureVariant.NotFound] = "Неверный ключ устройства.",
    _a[ActivateDeviceFailureVariant.Forbidden] = "Этот ключ уже используется.",
    _a);
export var useDeviceActivationForm = function () {
    var _a = React.useState(""), code = _a[0], setCode = _a[1];
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var activate = useActivateDevice();
    React.useEffect(function () {
        if (activate.isError) {
            if (activate.error !== null) {
                setError(activateDeviceErrorMap[activate.error]);
            }
            else {
                setError("Извините, произошла ошибка.");
            }
        }
    }, [activate.isError, activate.error]);
    var validate = function () {
        if (code.length === 0) {
            setError("Заполните поле.");
            return false;
        }
        return true;
    };
    var submit = function (evt) {
        evt.preventDefault();
        if (!validate()) {
            return;
        }
        setError(null);
        activate.mutate(code);
    };
    var onCodeChange = function (evt) {
        return setCode(evt.target.value);
    };
    return {
        code: { value: code, error: error, onChange: onCodeChange },
        submit: submit,
        pending: activate.isLoading,
    };
};
